// @ts-nocheck
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOneOnOneNotesOfAssignee,
  updateNotesStatusAction,
} from "../../../store/actions/notifications";
import {
  Button,
  CircularProgress,
  ClickAwayListener,
  Tooltip,
  Typography,
  useMediaQuery,
  Chip,
  Badge,
  Box,
} from "@mui/material";
import { EventNotesNotification } from "../../../assets/svgs/SVGs";
import EventNotesPositionModal from "../components/EventNotesPositionModal";
import { USER_ROLES } from "../../../staticData/userRoles";
import { isUserRole, isActiveRole } from "../../../utils/methods/storeFunc";
import { useNavigate } from "react-router-dom";
import NotesBadge, { ChatBadge } from "./NotesBadge";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { ON_SELECT_NEW_CHAT_ROOM_GROUP_CHAT } from "../../../store/constants/groupMessaging";
import { ON_SELECT_NEW_CHAT_ROOM } from "../../../store/constants/oneononemessaging";

const ChatUnreadTooltip = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store) => store.auth);
  const userRole = useSelector((state) => state.auth.user?.role);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { updatedChatMetaData, unreadMessagesData } = useSelector(
    (state) => state.notifications,
  );
  const { data } = useSelector(
    (state) => state?.groupMessaging?.unreadMessages,
  );
  const [showNotificationNote, setShowNotificationNote] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [positionOpen, setPositionOpen] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState("");

  const handlePositionOpen = () => setPositionOpen(true);
  const handlePositionClose = () => setPositionOpen(false);

  useEffect(() => {
    dispatch(
      fetchOneOnOneNotesOfAssignee({
        successCallback: (response) => {},
      }),
    );
  }, [dispatch]);

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const datePart = date.toLocaleDateString("en-US", {
      month: "long",
      day: "2-digit",
      year: "numeric",
    });
    const timePart = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${datePart} - ${timePart}`;
  };

  const LastActivity = ({ lastActivityAt }) => {
    return <div>{formatDateTime(lastActivityAt)}</div>;
  };

  const getUserName = (chat) => {
    return chat?.senderName;
  };

  const getSenderName = (message) => {
    return message?.senderName;
  };

  const handleChatNavigation = (chat, chatType) => {
    // Add your navigation logic here
    // navigate("/chat", { state: { chatId, chatType } });

    if (chatType == "group") {
      // add chat to selected chat room for group chat
      dispatch({
        type: ON_SELECT_NEW_CHAT_ROOM_GROUP_CHAT,
        payload: {
          chatRoom: { ...chat, _id: chat?.chatId },
        },
      });
      navigate("/event/chat");
    } else {
      // console.log(">> chat room click", chat);
      dispatch({
        type: ON_SELECT_NEW_CHAT_ROOM,
        payload: {
          chatRoom: { ...chat, _id: chat?.chatId },
        },
      });
      navigate("/event/chat/admin");
    }
    setShowNotificationNote(false);
  };

  const unReadNotification = useMemo(() => {
    const totalUnread = updatedChatMetaData?.reduce(
      (sum, data) => ({
        unread: sum?.unread + (data?.unreadMsgCount || 0),
        assigned: sum?.assigned + (data?.newAssigneeNoteCount || 0),
      }),
      { unread: 0, assigned: 0 },
    );
    return totalUnread || { unread: 0, assigned: 0 };
  }, [updatedChatMetaData]);

  const handleNavigation = (eventItem) => {
    const { positionIds, approved, isEstimateGenerated, eventId } = eventItem;
    if (isUserRole(userRole, USER_ROLES.CONTRACTOR)) {
      if (
        !positionIds ||
        !positionIds.positions ||
        positionIds.positions.length === 0
      )
        return;
    }
    let path = "";
    if (!approved && !isEstimateGenerated) {
      path = "/event/new-request/details";
    } else if (!approved && isEstimateGenerated) {
      path = "/event/estimates/view";
    } else if (approved && isEstimateGenerated) {
      path = "/event/details";
    }
    if (path) {
      navigate(path, { state: { id: eventId } });
      dispatch(updateNotesStatusAction({ status: true }));
    }
  };

  // const shouldShowNotes = useMemo(() => {
  //   if (isActiveRole(USER_ROLES.CLIENT)) {
  //     if (auth?.isApproved) return true;
  //     else return false;
  //   } else if (isActiveRole(USER_ROLES.CONTRACTOR)) {
  //     if (unReadNotification?.unread > 0) return true;
  //     else return false;
  //   } else {
  //     return true;
  //   }
  // }, [auth?.isApproved, unReadNotification?.unread]);

  const messageList = useMemo(() => {
    return [
      ...(data?.groupChats?.map((chat) => ({
        ...chat,
        type: "group",
      })) || []),
      ...(data?.oneOnOneChats?.map((chat) => ({
        ...chat,
        type: "oneOnOne",
      })) || []),
    ].sort((a, b) => b.messages.timestamp.localeCompare(a.messages.timestamp));
  }, [data?.groupChats, data?.oneOnOneChats]);

  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          setShowNotificationNote(false);
        }}
      >
        <Tooltip
          open={showNotificationNote}
          onClose={() => setShowNotificationNote(true)}
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: "1000px",
                border: "2px solid #D175B6",
                borderRadius: "16px",
                padding: "12px 2px 12px 12px",
                boxShadow:
                  "0px 0px 60px 0px #000000, 0px 0px 200px 0px #000000",
              },
            },
          }}
          title={
            <>
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                <Box
                  sx={{
                    width: "26.875em",
                    maxHeight: { xs: "60vh", md: "50vh", lg: "40vh" },
                    overflowY: "auto",
                    padding: "0 12px 0 0",
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#1a1a1a",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#D175B6",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Typography
                    fontWeight="500"
                    fontSize="1.25rem"
                    color="#FFFFFF"
                    sx={{ textAlign: "center", mb: 2 }}
                  >
                    UNREAD MESSAGES
                  </Typography>

                  {messageList?.map((chat) => {
                    const latestMessage = chat?.messages;
                    const unreadCount = chat?.unreadCount;

                    return (
                      <Box key={chat.chatId} sx={{ mb: 2 }}>
                        <Box
                          sx={{
                            width: "100%",
                            borderRadius: "5px",
                            padding: "10px",
                            background: "#FFFFFF1A",
                            cursor: "pointer",
                          }}
                          onClick={() => handleChatNavigation(chat, chat?.type)}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              // mb: 1,
                            }}
                          >
                            <Typography fontWeight="400" fontSize="1rem">
                              {chat.type === "group"
                                ? chat.groupName
                                : getUserName(latestMessage)}
                            </Typography>
                            <Chip
                              label={`${unreadCount} unread`}
                              size="small"
                              sx={{
                                background: "#D175B6",
                                color: "#FFFFFF",
                                fontWeight: 500,
                                fontSize: "0.75rem",
                              }}
                            />
                          </Box>
                          <Typography
                            fontWeight="300"
                            fontSize="0.875rem"
                            color="#FFFFFFB3"
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {chat.type === "group" && (
                              <Typography sx={{ fontWeight: "200" }}>
                                {getSenderName(latestMessage)}
                              </Typography>
                            )}
                            {latestMessage.content}
                          </Typography>
                          <Typography
                            fontWeight="300"
                            fontSize="0.75rem"
                            color="#FFFFFF80"
                            sx={{ mt: 0.5 }}
                          >
                            {formatDateTime(latestMessage.timestamp)}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              )}
            </>
          }
          arrow
        >
          <Box
            sx={{
              lineHeight: "0",
              marginRight: isSmallScreen ? "12px" : "24px",
              marginTop: "0.5rem",
            }}
            onClick={() => {
              setShowNotificationNote(true);
            }}
          >
            <Button
              sx={{
                minWidth: "0",
                background: "transparent",
                border: "none",
                boxShadow: "none",
                padding: "0",
                ":hover": {
                  background: "transparent",
                  border: "none",
                  boxShadow: "none",
                },
              }}
            >
              <ChatBadge totalUnread={data?.totalUnreadCount}>
                <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: "2rem" }} />
              </ChatBadge>
            </Button>
          </Box>
        </Tooltip>
      </ClickAwayListener>
      {positionOpen && (
        <EventNotesPositionModal
          LastActivity={LastActivity}
          open={positionOpen}
          onClose={handlePositionClose}
          updatedChatMetaData={updatedChatMetaData?.filter(
            (item) => item.eventId === selectedEventId,
          )}
        />
      )}
    </>
  );
};

export default ChatUnreadTooltip;